<template>
  <Cards>
    <div>
      <TopSearch :adminShow="false" :search-show="true" @searchKey="getSearchKey"/>
    </div>
  </Cards>
  <Cards>
    <div>
      <div class="top_tips">
        <div class="top_tips__title">
          <h2 style="font-weight: 500;font-size: 16px !important;">{{ $t('common.customer.followup.list') }}</h2>
          <el-icon v-if="helpEnabled" class="top_tips__help" @click="openGuideManually">
            <QuestionFilled/>
          </el-icon>
        </div>
        <div>
          <el-button type="primary" size="small" :loading="followIsLoading||isBuildDB" :icon="Finished"
                     @click="handleClickFollow">
            {{
              $t("common.followup")
            }}
          </el-button>
          <el-button type="primary" size="small" :icon="Timer" @click="delayDayAll">{{
              $t("common.bulk.delay")
            }}
          </el-button>
          <el-button size="small" :icon="CircleClose" @click="cancelAll">{{
              $t("common.bulk.cancel")
            }}
          </el-button>
        </div>
      </div>
      <el-table
          v-loading="isLoading"
          id="sp_tables"
          ref="multipleTableRef"
          :data="tableData"
          style="width: 100%; margin-top: 10px;"
          @selection-change="handleSelectionChange"
          @select="handleCheck"
          @select-all="handleClickSelectAll"
          :cell-style="rowClassName"
          :header-cell-class-name="selectionHeaderClass"
          :header-cell-style="headerClassName"
          :row-key="row => row.id"
          @cell-mouse-leave="clearVisiblePopover"
      >
        <el-table-column type="selection" width="40" :selectable="checkSelectable" :reserve-selection="true" :class-name="selectionHeaderClass"/>
        <el-table-column
            v-for="item in table_columns_follow"
            :key="item.key"
            :label="item.key"
            :prop="item.value"
            :width="handleClickSelectWidth(item)"
            :min-width="handleClickSelectMinWidth(item)"
        >
          <!--          :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
          <template #default="{row}">
            <template v-if="item.value==='customerCode'">
              <div :ref="ref => (refMap[`${row.id}_code`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_code`], row, 7)"
                   v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                   class="over_normal"
                   :key="row.customerCode">
                {{
                  getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.customerCode }}
              </div>
            </template>
            <template v-else-if="item.value === 'customerName'">
              <div :ref="el => setRef(el, row)"
                   class="over_text"
                   :key="row.customerName"
                   @mouseenter="handleMouseEnter(row)"
                   @click.native.stop="toDetail(row)">
                {{ row.customerName }}
              </div>
            </template>
            <template v-else-if="item.value==='customerOrigin'">
                <div class="over_normal">
                  <el-tag type="info"
                          v-if="getDetailFirstName(row?.mailCustomerOriginDetailVoList)"
                          :ref="ref => (refMap[`${row.id}_source`] = ref)"
                          @mouseover.stop="shouldShowTagNamePopover(row?.mailCustomerOriginDetailVoList) && handleRef(refMap[`${row.id}_source`], row, 6)">
                    {{
                      shouldShowTagNamePopover(row?.mailCustomerOriginDetailVoList)
                          ? formatText(getDetailFirstName(row?.mailCustomerOriginDetailVoList), sizeMaxNumber, true)
                          : getDetailFirstName(row?.mailCustomerOriginDetailVoList)
                    }}
                  </el-tag>
                  <el-button v-if="getDetailExtraCount(row?.mailCustomerOriginDetailVoList) > 0"
                             link
                             type="primary"
                             class="tag-popover-trigger"
                             :ref="ref => (refMap[`${row.id}_source_more`] = ref)"
                             @mouseover.stop="handleRef(refMap[`${row.id}_source_more`], row, 12)">
                    +{{ getDetailExtraCount(row?.mailCustomerOriginDetailVoList) }}
                  </el-button>
              </div>
            </template>
            <template v-else-if="item.value==='customerIntention'">
                <div class="over_normal">
                  <el-tag type="info"
                          v-if="getDetailFirstName(row?.mailProductDetailVoList)"
                          :ref="ref => (refMap[`${row.id}_product`] = ref)"
                          @mouseover.stop="shouldShowTagNamePopover(row?.mailProductDetailVoList) && handleRef(refMap[`${row.id}_product`], row, 9)">
                    {{
                      shouldShowTagNamePopover(row?.mailProductDetailVoList)
                          ? formatText(getDetailFirstName(row?.mailProductDetailVoList), sizeMaxNumber, true)
                          : getDetailFirstName(row?.mailProductDetailVoList)
                    }}
                  </el-tag>
                  <el-button v-if="getDetailExtraCount(row?.mailProductDetailVoList) > 0"
                             link
                             type="primary"
                             class="tag-popover-trigger"
                             :ref="ref => (refMap[`${row.id}_product_more`] = ref)"
                             @mouseover.stop="handleRef(refMap[`${row.id}_product_more`], row, 13)">
                    +{{ getDetailExtraCount(row?.mailProductDetailVoList) }}
                  </el-button>
              </div>
            </template>
            <template v-else-if="item.value ==='zoneAddress'">
              <div style="cursor: pointer;">
                <!-- 触发内容1 -->
                <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                          @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                          v-if="row.zoneAddress"
                          :src="flag[row.zoneCode]"
                          style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                          lazy
                />
              </div>
            </template>
            <template v-else-if="item.value === 'customerType'">
              <div :ref="ref => (refMap[`${row.id}_type`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.id}_type`], row, 4)"
                   v-if="getTextLength(row.customerType) > sizeMaxNumber"
                   :key="row.customerType"
                   class="over_normal">
                {{
                  getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.customerType }}
              </div>
            </template>
            <template v-else-if="item.value === 'customerLevel'">
              <el-button size="small" link type="primary" style="width: 100%; padding: 0;">
                {{ row.customerLevel }}
              </el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.cz')" :width="lang==='en'?210:140">
          <template #default="{ row, column, $index }">
            <div class="follow-setting-actions">
              <el-button class="follow-setting-action-btn" size="small" type="primary" @click="follow(row, column, $index)" link
              >{{ $t('common.followup') }}
              </el-button
              >
              <el-button class="follow-setting-action-btn" size="small" type="primary" @click="delay(row, column, $index)" link
              >{{ $t('common.delay') }}
              </el-button
              >
              <ConfirmDeletePopover
                  :visible="row.popoverVisibleCancel"
                  :width="164"
                  :message="$t('sys.message.ask.followup.cancel')"
                  @update:visible="(value) => (row.popoverVisibleCancel = value)"
                  @confirm:delete="handleCancel(row, column, $index)"
              >
                <template #settings>
                  <el-button
                      class="follow-setting-action-btn"
                      type="warning"
                      size="small"
                      @click="cancel(row, column, $index)"
                      link
                  >{{ $t('common.cancel') }}
                  </el-button
                  >
                </template>
              </ConfirmDeletePopover
              >
            </div>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
        </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <Pagination v-model:modelValue="currentFlow"
                  v-model:pageSizeValue="sizeFLow"
                  :total="totalsFlow"
                  v-if="totalsFlow"
                  ref="PageZQ"
                  @change="handleCurrentChange"
                  @checkAllItemPage="checkAllItemPage"
                  @unCheckAllItemPage="unCheckAllItemPage"
                  @getSelect="getSelectValue"
                  :multipleSelection="multipleSelection"
                  :is-show-select="true"
      ></Pagination>
    </div>
  </Cards>

  <Dialog
      v-model="dialogVisible"
      :title="$t('common.yst')"
      :dialogVisible="dialogVisible"
      :isHeadLine="false"
      :width="'400'"
      @update:dialogVisible="(val) => (dialogVisible = val)"
  >
    <template #content>
      <el-date-picker
          size="small"
          style="width: 200px;margin: auto;display: flex;margin-top: 10px"
          v-model="delayDay"
          type="date"
          :placeholder="$t('common.slt')"
          :disabled-date="disabledDate"
      />
    </template>
    <template #footer>
      <div class="buttons_bottom">
        <el-button size="small" @click="dialogVisible = false">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="addDelayDay" :loading="isLoadingDelay">{{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <Dialog
      v-model="cancelAllVisible"
      :dialogVisible="cancelAllVisible"
      :isHeadLine="false"
      :title="$t('sys.team.info')"
      :width="'420'"
      @update:dialogVisible="(val) => (cancelAllVisible = val)"
      align-center
  >
    <template #content>
      <div class="content_box" style="margin: 0px 8px">
        <div class="inner_text" style="font-size: 14px;">{{ $t('common.sl1') }}</div>
      </div>
    </template>
    <template #footer>
      <div class="buttons_bottom">
        <el-button size="small" @click="cancelAllVisible = false">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleCancelAll"
                   :loading="isLoadingCancel">
          {{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <!--  el-popover-->
  <el-popover
      :visible="visiblePopover"
      :transition="popoverTransition"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      :show-after="1200"
      effect="dark"
      placement="right"
  >
  <div @mouseenter="keepPopoverVisible" @mouseleave="clearVisiblePopover">
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content"
           v-html="
                          '<div>' +
                          activeItemElpopover.maiContactVOList
                            .map((item) => {
                              return `${item.contactName}<br/>`;
                            })
                            .join('') +
                          '</div>'
                        "
      ></div>
    </template>
    <template v-else-if="popoverType === 2">
      <!-- 业务逻辑2 -->
      <div class="popover-content"
           v-html="
                '<div>' +
                activeItemElpopover.mangerVOList
                  .map((item) => {
                    return `${item.managerName}<br/>`;
                  })
                  .join('') +
                '</div>'
              "
      ></div>
    </template>
    <template v-else-if="popoverType===3">
      <!-- 业务逻辑3 -->
      <div class="popover-content">
        {{ activeItemElpopover.zoneAddress }}
      </div>
    </template>
    <template v-else-if="popoverType===4">
      <div class="popover-content">
        {{ activeItemElpopover.customerType }}
      </div>
    </template>
    <template v-else-if="popoverType===5">
      <div class="popover-content">
        {{ activeItemElpopover.customerName }}
      </div>
    </template>
    <template v-else-if="popoverType===6">
      <div class="popover-content">
        {{ getDetailFirstName(activeItemElpopover?.mailCustomerOriginDetailVoList) }}
      </div>
    </template>
    <template v-else-if="popoverType===12">
      <div class="popover-content popover-tag-list">
        <el-tag v-for="(item, index) in getRemainingDetailList(activeItemElpopover?.mailCustomerOriginDetailVoList)"
                :key="`${item.name}_${index}`"
                type="info"
                disable-transitions
                class="popover-tag-item">
          {{ formatText(item.name, sizeMaxNumber, true) }}
        </el-tag>
      </div>
    </template>
    <template v-else-if="popoverType===7">
      <div class="popover-content">
        {{ activeItemElpopover.customerCode }}
      </div>
    </template>
    <template v-else-if="popoverType === 9">
      <div class="popover-content">
        {{ getDetailFirstName(activeItemElpopover?.mailProductDetailVoList) }}
      </div>
    </template>
    <template v-else-if="popoverType === 13">
      <div class="popover-content popover-tag-list">
        <el-tag v-for="(item, index) in getRemainingDetailList(activeItemElpopover?.mailProductDetailVoList)"
                :key="`${item.name}_${index}`"
                type="info"
                disable-transitions
                class="popover-tag-item">
          {{ formatText(item.name, sizeMaxNumber, true) }}
        </el-tag>
      </div>
    </template>
  </div>
  </el-popover>

  <!-- 功能说明轮播弹窗（helpEnabled 为 false 时整个模块不渲染） -->
  <GuideCarouselDialog
      v-if="helpEnabled"
      v-model="guideVisible"
      :title="$t('follow.guide.title')"
      :slides="guideSlides"
      :never-again-text="$t('follow.guide.never.again')"
      width="1360px"
      height="560px"
      text-height="130px"
      @never-again="handleGuideNeverAgain"
      @close-icon="handleGuideClose"
  />
</template>
<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {dayjs, ElMessage, ElTable} from "element-plus";

import Cards from "./Cards.vue";
import TopSearch from "./TopComponents/TopSearch.vue";
import Dialog from "@/components/Dialog.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import GuideCarouselDialog from "@/components/GuideCarouselDialog.vue";
import guideFollow1 from "@/assets/guide/follow_1.png";
import guideFollow2 from "@/assets/guide/follow_2.png";
import guideFollow3 from "@/assets/guide/follow_3.png";

import {getMailCustomerFollow, batchDelayCancel} from "@/api/customer.js";
import {useStore} from "vuex";
import {table_columns_follow} from "@/views/Customer/map";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import flag from "@/assets/flag";
import {flexWidth, flexTagWidth} from "@/utils/tableWidth";
import {i18n} from "@/lang"
import {debouncePlus, isEmpty} from "@/utils/mylodash";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import {CircleClose, Finished, Timer, QuestionFilled} from "@element-plus/icons-vue";
import {Storage} from "@/utils/storage"
import {CustomerTable} from "@/views/Marketing/db_customer";
import sessionStore from "@/utils/sessionStore";
import { shouldShowHelpDialog, markHelpDialogClosedByIcon, markHelpDialogNeverAgain, isHelpDialogEnabled } from "@/utils/helpDialog";
import { PAGE_KEYS } from "@/config/help-dialog-config";

const store = useStore()
const router = useRouter();
const teamId = computed(() => store.state.email.teamID);
// 语言
const lang = computed(() => store.state.system.langLocal)

// 功能说明轮播弹窗
const guideVisible = ref(false)
// 帮助模块/入口开关（由 helpDialog.js 的 HELP_DIALOG_ENABLED_CONFIG 配置项控制，暂时隐藏时入口与弹窗均不渲染）
const helpEnabled = isHelpDialogEnabled(PAGE_KEYS.FOLLOW)
// 标记弹窗是否为“自动弹出”：仅自动弹出被关闭时才上报冷却，手动点问号打开的查看不影响冷却状态
const guideAutoShown = ref(false)
// 点击问号图标手动打开（不改变冷却状态）
const openGuideManually = () => {
  guideAutoShown.value = false
  guideVisible.value = true
}
// 点击「近期不弹出」：进入 90 天冷却期（问号图标仍可手动打开）
const handleGuideNeverAgain = () => {
  markHelpDialogNeverAgain(PAGE_KEYS.FOLLOW)
  guideAutoShown.value = false
}
// 点击右上角关闭图标：仅在自动弹出场景下进入 7 天冷却期，避免手动查看后误缩短已有冷却期
const handleGuideClose = () => {
  if (guideAutoShown.value) {
    markHelpDialogClosedByIcon(PAGE_KEYS.FOLLOW)
  }
  guideAutoShown.value = false
}
// 轮播内容：上图下文，图片来自 src/assets/guide
const guideSlides = computed(() => [
  {
    image: guideFollow1,
    title: i18n.global.t('follow.guide.slide1.title'),
    desc: i18n.global.t('follow.guide.slide1.desc'),
  },
  {
    image: guideFollow2,
    title: i18n.global.t('follow.guide.slide2.title'),
    desc: i18n.global.t('follow.guide.slide2.desc'),
  },
  {
    image: guideFollow3,
    title: i18n.global.t('follow.guide.slide3.title'),
    desc: i18n.global.t('follow.guide.slide3.desc'),
  },
])
// 延迟时间
const delayDay = ref("");

// table 的ref 对象
const multipleTableRef = ref();
// 表格是否加载
const isLoading = ref(false)
// 批量选中的客户
const multipleSelection = computed(() => store.state.customer.multipleSelection)


const disabledDate = (time) => {
  return time.getTime() < Date.now();
};

// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))
const getSearchKey = async (value) => {
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  searchValue.value = newObj;
  console.log(searchValue.value, "ffff");
  // 列表数据
  await getListFollow();
  isSelectAll.value ? multipleTableRef.value?.toggleAllSelection() : multipleTableRef.value?.clearSelection()
  await resetInit()
};

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const isApplyingShiftSelection = ref(false)
const isRestoringSelection = ref(false)
const hasLoadedSelectAllRows = ref(false)
const shiftAnchorIndex = ref(null)
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};

const buildMergedSelectedRows = (globalRows) => {
  const selectedMap = new Map()

  Object.values(globalRows).flat().forEach((item) => {
    if (item?.id) {
      selectedMap.set(item.id, item)
    }
  })

  return Array.from(selectedMap.values())
}

const syncSelectionStoreByPage = async (val = []) => {
  const currentPage = currentFlow.value
  const currentPageSelection = Array.isArray(val) ? val : []
  const currentGlobalSelectedRows = {
    ...normalizeGlobalSelectedRows(store.state.customer.globalSelectedRows)
  }

  currentGlobalSelectedRows[currentPage] = currentPageSelection

  const allSelectedRows = buildMergedSelectedRows(currentGlobalSelectedRows)

  await store.commit("customer/setGlobalSelectedRows", currentGlobalSelectedRows)
  await store.commit("customer/setSelectedRows", allSelectedRows)
  await store.commit("customer/setMultipleSelection", allSelectedRows)

  await CustomerTable.clear()
  if (allSelectedRows.length > 0) {
    await CustomerTable.bulkAdd(allSelectedRows.map(item => ({id: item.id, customerId: item.customerId})))
  }
}

const handleSelectionChange = async (val) => {
  console.log(val, '====')
  if (isApplyingShiftSelection.value || isRestoringSelection.value) return
};

// 分页
const currentFlow = ref(1);
const sizeFLow = ref(10);
const totalsFlow = ref(0);
const isSelectAll = ref(false);

async function handleCurrentChange(page) {
  hidePopoverImmediately(true)
  const {pageNo, pageSize} = page
  currentFlow.value = pageNo;
  sizeFLow.value = pageSize;
  //  重新获取数据
  await getListFollow();
  // 翻页时清空已缓存的全选记录
  hasLoadedSelectAllRows.value = false
  // 全选状态下，需要重新获取全部数据并恢复勾选
  if (isSelectAll.value) {
    await getSelectValue()
  }
}

const handleCheck = async (selection, row) => {
  if (isSelectAll.value) {
    isSelectAll.value = false;
    shiftAnchorIndex.value = null
    await PageZQ.value?.setIsSelectAll(false)
  }
  if (!row) {
    await syncSelectionStoreByPage(selection)
    return
  }

  const clickedIndex = tableData.value.findIndex(item => item.id === row.id)
  const isRowSelectedNow = Array.isArray(selection) && selection.some(item => item.id === row.id)

  if (!isShiftPressed.value || shiftAnchorIndex.value === null || shiftAnchorIndex.value === -1 || clickedIndex === -1) {
    shiftAnchorIndex.value = clickedIndex
    await syncSelectionStoreByPage(selection)
    return
  }

  const start = Math.min(shiftAnchorIndex.value, clickedIndex)
  const end = Math.max(shiftAnchorIndex.value, clickedIndex)
  isApplyingShiftSelection.value = true
  try {
    for (let i = start; i <= end; i++) {
      const r = tableData.value[i]
      if (r) {
        multipleTableRef.value?.toggleRowSelection(r, isRowSelectedNow)
      }
    }
    await nextTick(async () => {
      await syncSelectionStoreByPage(multipleTableRef.value?.getSelectionRows?.() ?? selection)
    })
  } finally {
    await nextTick(() => {
      isApplyingShiftSelection.value = false
    })
  }
}

const checkAllItemPage = () => {
  multipleTableRef.value.clearSelection()
  isSelectAll.value = true
  shiftAnchorIndex.value = null
}
const unCheckAllItemPage = () => {
  multipleTableRef.value.clearSelection()
  isSelectAll.value = false
  shiftAnchorIndex.value = null
}
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick()
  await nextTick()

  if (!isSelectAll.value) {
    multipleTableRef.value?.clearSelection()
    await store.commit("customer/setGlobalSelectedRows", {});
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setMultipleSelection", [])
    return
  }

  tableData.value.forEach((item) => {
    // 第三个参数 true：即使当前行 checkbox 被 selectable 禁用，也允许程序选中，保证禁用态仍显示蓝色勾选
    multipleTableRef.value?.toggleRowSelection(item, true, true)
  })
  await nextTick(async () => {
    const currentSelection = multipleTableRef.value?.getSelectionRows?.() ?? []
    await store.commit("customer/setMultipleSelection", currentSelection)
    await syncSelectionStoreByPage(currentSelection)
  })
}

// 客户跟进表数据
const tableData = ref([]);
const getListFollow = async () => {
  hidePopoverImmediately(true)
  isLoading.value = true;
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  let res = await getMailCustomerFollow({
    ...searchValue.value,
    pageSize: sizeFLow.value,
    pageNo: currentFlow.value,
    teamId: teamId.value
  });
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  isLoading.value = false;
  const {records, total, current, size} = res.result;
  tableData.value = records;
  sizeFLow.value = size;
  totalsFlow.value = total;
  currentFlow.value = current;
};


const isBuildDB = ref(false)
const getListFollowAll = async () => {
  isBuildDB.value = true
  try {
    const res = await getMailCustomerFollow({
      ...searchValue.value,
      teamId: teamId.value,
      isSelectAll: 0,
    });
    if (res.code !== 200) {
      ElMessage.error(res.message);
      return false;
    }
    const arrayList = res.result.map(item => ({id: item.id, customerId: item.customerId}))
    await CustomerTable.clear()
    await CustomerTable.bulkAdd(arrayList)
    return true
  } finally {
    isBuildDB.value = false
  }
}

// 跟进
const isFllow = ref(false)
const follow = async (row) => {
  isFllow.value = true
  localStorage.setItem('follow', JSON.stringify(row))
  const query = {type: "follow"};
  if (row.customerId) {
    query.customerId = row.customerId;
  }
  const url = row.customerId ? `/email/write_mail?type=follow&customerId=${row.customerId}` : `/email/write_mail?type=follow`
  const newUrl = router.resolve(url)
  openNewWindow(newUrl.href)
  // 重新获取列表数据
  await getListFollow();
  await resetInit()
  // //   取消目标 邮件跟进
  let timer = setTimeout(() => {
    handleCancel(row)
    clearTimeout(timer)
  }, 300)
};
const openNewWindow = (url) => {
  window.open(url, "_blank");
};

// 客户批量跟进
const followIsLoading = ref(false)
const handleClickFollow = async () => {
  // 选中的结果需要缓存
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  if (isSelectAll.value && !await getListFollowAll()) {
    return
  }
  //
  // const mailCustomerList = multipleSelection.value.map(item => ({customerId: item.customerId}))
  // await CustomerTable.clear()
  // await CustomerTable.bulkAdd(mailCustomerList)
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const followSearch = encodeURIComponent(JSON.stringify(searchValue.value ?? {}))
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: 3, step: 0, isOpen: 1, followSearch}
  })
  window.open(routeUrl.href, '_target')
  isFllow.value = false
  await resetInit({clearCustomerTable: false})
}


// 延迟对话框
const dialogVisible = ref(false);

// 延迟
const activeItem = ref(null);
const delay = async (row, column, $index) => {
  dialogVisible.value = true;
  activeItem.value = row;
};

// 批量延迟
const delayDayAll = () => {
  console.log(isEmpty(multipleSelection.value), 'multipleSelection')
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  dialogVisible.value = true;
};

// 确认添加延迟时间
const isLoadingDelay = ref(false)
const addDelayDay = async () => {
  if (delayDay.value === "") {
    ElMessage.warning(i18n.global.t('please.enter.time'));
    return;
  }
  // 确认添加
  let targetObj = {
    mailCustomerFollowListDTOList: [],
    teamId: teamId.value,
    time: dayjs(delayDay.value).format("YYYY-MM-DD HH:mm:ss"),
    type: 1,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  if (multipleSelection.value.length >= 1) {
    // 批量
    let result = multipleSelection.value.map((item) => {
      return {
        customerId: item.customerId,
        customerTypeId: item.customerTypeId,
        id: item.id,
      };
    });
    targetObj.mailCustomerFollowListDTOList = [...result];
    console.log("all", targetObj);
  } else {
    // 单个
    const {customerId, customerTypeId, id} = activeItem.value;
    targetObj.mailCustomerFollowListDTOList = [
      {customerId, customerTypeId, id},
    ];

    console.log("dan", targetObj);
  }
  if (isSelectAll.value) {
    delete targetObj.mailCustomerFollowListDTOList
  }
  console.log(targetObj, "批量取消");
  isLoadingDelay.value = true
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    isLoadingDelay.value = false
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  isLoadingDelay.value = false
  dialogVisible.value = false;
  delayDay.value = "";
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
};


// 取消对话框
const popoverVisibleCancel = ref(false);
// 取消
const cancel = async (row, colum, $index) => {
  row.popoverVisibleCancel = true;
};
// 确认取消
const handleCancel = async (row) => {
  const {customerId, customerTypeId, id, alertDay} = row;
  let targetObj = {
    mailCustomerFollowListDTOList: [{id,}],
    teamId: teamId.value,
    type: 2,
  };
  console.log(targetObj, "targetObj");
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  if (!isFllow.value) {
    ElMessage.success(res.message);
  }
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  isFllow.value = false
  await resetInit()
};

// 批量取消对话框
const cancelAllVisible = ref(false);
// 批量取消
const cancelAll = () => {
  if (isEmpty(multipleSelection.value)) {
    ElMessage.warning(i18n.global.t('30001'));
    return;
  }
  cancelAllVisible.value = true;
};
// 确定批量取消
const isLoadingCancel = ref(false)
const handleCancelAll = async () => {
  const result = multipleSelection.value
  console.log(result)
  const targetList = result.map((item) => {
    return {
      customerId: item.customerId,
      customerTypeId: item.customerTypeId,
      id: item.id,
      alertDay: item.alertDay,
    };
  });
  const targetObj = {
    mailCustomerFollowListDTOList: [...targetList],
    teamId: teamId.value,
    type: 2,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  if (isSelectAll.value) {
    delete targetObj.mailCustomerFollowListDTOList
  }
  console.log(targetObj, '批量延迟')
  isLoadingCancel.value = true
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    isLoadingCancel.value = false
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  isLoadingCancel.value = false
  cancelAllVisible.value = false;
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
};

onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
  // 首次进入自动弹出功能说明（由后端下发的冷却时间控制，冷却期内不再自动弹出）
  shouldShowHelpDialog(PAGE_KEYS.FOLLOW).then((show) => {
    if (show) {
      guideVisible.value = true
      guideAutoShown.value = true
    }
  })
  // await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
});

onBeforeUnmount(() => {
  hidePopoverImmediately(true)
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

watch(() => teamId.value, async () => {
  await getListFollow();
  await store.dispatch('countshow/getTeamAllDataApis')
  await resetInit()
})

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const selectionHeaderClass = ({columnIndex}) => {
  if (columnIndex === 0) {
    return isSelectAll.value ? 'disabledCheck' : 'abledCheck'
  }
  return ''
}

const toDetail = (row) => {
  const newUrl = router.resolve('/email/customer/detail/' + row.customerId + '?type=1')
  openNewWindow(newUrl.href);
}

// "全选所有页"激活时禁用逐行勾选，避免与全选状态冲突
const checkSelectable = (row, index) => {
  return !isSelectAll.value;
}

// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// popover 过渡动画：正常显隐保留渐隐渐显，切换触发元素时临时置为 none，保证新 popover 以最终状态直接呈现
const popoverTransition = ref('el-fade-in-linear')
// 隐藏 popover 的定时器，展示前需取消，避免闪动
let popoverHideTimer = null
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const clearPopoverHideTimer = () => {
  if (popoverHideTimer) {
    clearTimeout(popoverHideTimer)
    popoverHideTimer = null
  }
}

const getPopoverRefElement = (refTarget) => {
  if (!refTarget) return null
  return refTarget?.$el ?? refTarget
}

const isValidPopoverRef = (refTarget) => {
  const el = getPopoverRefElement(refTarget)
  return !!el
      && typeof el.getBoundingClientRect === 'function'
      && typeof el.isConnected === 'boolean'
      && el.isConnected
}

const hidePopoverImmediately = (resetActive = false) => {
  handleRef.cancel()
  clearPopoverHideTimer()
  visiblePopover.value = false
  tempRef.value = undefined

  if (resetActive) {
    popoverType.value = 0
    activeItemElpopover.value = null
  }
}

const handleRef = debouncePlus((ref, item, type) => {
  const nextRef = getPopoverRefElement(ref)
  if (!isValidPopoverRef(nextRef)) {
    hidePopoverImmediately(true)
    return
  }
  clearPopoverHideTimer()
  // popover 已显示时切换触发元素，先隐藏再展示，避免新内容在旧位置渲染一帧造成闪动
  if (visiblePopover.value && tempRef.value !== nextRef) {
    // 切换期间临时禁用过渡动画，避免离场动画暴露内容与位置的变化过程
    popoverTransition.value = 'none'
    visiblePopover.value = false
    nextTick(() => {
      if (!isValidPopoverRef(nextRef)) {
        hidePopoverImmediately(true)
        return
      }
      tempRef.value = nextRef
      popoverType.value = type
      activeItemElpopover.value = item
      visiblePopover.value = true
      // 切换呈现完成后恢复渐隐渐显动画
      nextTick(() => {
        popoverTransition.value = 'el-fade-in-linear'
      })
    })
    return
  }
  tempRef.value = nextRef
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const normalizeGlobalSelectedRows = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value
  }
  return {}
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  await syncSelectionStoreByPage(val)
}

// 重置记录
const PageZQ = ref()
const resetInit = async ({clearCustomerTable = true} = {}) => {
  try {
    // parent
    isSelectAll.value = false
    hasLoadedSelectAllRows.value = false
    shiftAnchorIndex.value = null
    // child
    await PageZQ.value.setIsSelectAll(isSelectAll.value)
    // 清空选项
    await store.commit("customer/setGlobalSelectedRows", {});
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setMultipleSelection", [])
    if (clearCustomerTable) {
      await CustomerTable.clear()
    }
    await multipleTableRef.value?.clearSelection()
  } catch (e) {
    console.log(e)
  }
}


const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isCounterElection = computed(() => store.state.customer.isCounterElection);
// 记录历史记录
const resetSelection = async () => {
  if (isSelectAll.value) return

  await nextTick();
  await nextTick(); // 双重保险，确保 DOM 和组件都挂载完成

  console.log(multipleTableRef?.value, tableData.value, selectedRows.value, 'treeTable?.value')

  if (!multipleTableRef?.value || !Array.isArray(selectedRows.value)) return;

  isRestoringSelection.value = true
  tableData.value.forEach((item) => {
    const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
    console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected');
    multipleTableRef?.value.toggleRowSelection(item, isSelected);
  });
  await nextTick(() => {
    isRestoringSelection.value = false
  })
};

// 当前页数据发生变化
watch(() => tableData.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})


const clearVisiblePopover = () => {
  // 取消尚未执行的展示任务，并复用同一个隐藏定时器，避免旧定时器误关新 popover
  handleRef.cancel()
  clearPopoverHideTimer()
  popoverHideTimer = setTimeout(() => {
    visiblePopover.value = false
    popoverHideTimer = null
  }, POPOVER_DELAY_TIME + 10)
}

// 鼠标移入 popover 内容时保持显示，避免 popover 覆盖触发元素时反复显隐跳动
const keepPopoverVisible = () => {
  handleRef.cancel()
  clearPopoverHideTimer()
}


// 设置 临界值 width
const middleValueWidth = ref(165)
// 字数大致限制
const sizeMaxNumber = ref(16)
const getDetailList = (list = []) => {
  if (!Array.isArray(list)) {
    return []
  }

  return list.filter(item => item?.name !== '')
}

// 标签计算结果缓存：以源数组为键，避免每次渲染都 filter/slice 生成新数组，导致 popover 内标签列表被重建而闪动
const EMPTY_DETAIL_INFO = {firstName: '', extraCount: 0, remainingList: []}
const detailInfoCache = new WeakMap()
const getDetailInfo = (list) => {
  if (!Array.isArray(list)) {
    return EMPTY_DETAIL_INFO
  }
  let info = detailInfoCache.get(list)
  if (!info || info.sourceLength !== list.length) {
    const validList = getDetailList(list)
    info = {
      sourceLength: list.length,
      firstName: validList[0]?.name || '',
      extraCount: Math.max(validList.length - 1, 0),
      remainingList: validList.slice(1)
    }
    detailInfoCache.set(list, info)
  }
  return info
}

const getDetailFirstName = (list = []) => {
  return getDetailInfo(list).firstName
}

const getDetailExtraCount = (list = []) => {
  return getDetailInfo(list).extraCount
}

const getRemainingDetailList = (list = []) => {
  return getDetailInfo(list).remainingList
}

const shouldShowTagNamePopover = (list = []) => {
  return getTextLength(getDetailFirstName(list)) > sizeMaxNumber.value
}

// 按“实际展示内容”(截断后的首标签 + 是否有 +N 按钮)计算标签列宽
const getTagColWidth = (listField, title) => {
  const rows = tableData.value
  const items = Array.isArray(rows) ? rows.map((row) => {
    const list = row?.[listField]
    const name = getDetailFirstName(list)
    return {
      text: shouldShowTagNamePopover(list) ? formatText(name, sizeMaxNumber.value, true) : name,
      hasExtra: getDetailExtraCount(list) > 0
    }
  }) : []
  return flexTagWidth(items, title)
}

const handleClickSelectWidth = (item) => {
  if (item.value === "customerCode") {
    return flexWidth('customerCode', tableData.value, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', tableData.value, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', tableData.value, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', tableData.value, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerOrigin') {
    return getTagColWidth('mailCustomerOriginDetailVoList', i18n.global.t('common.customer.source'))
  } else if (item.value === 'customerIntention') {
    return getTagColWidth('mailProductDetailVoList', i18n.global.t('common.interest.product'))
  } else if (item.value === 'createName' || item.value === 'maiContactVOList' || item.value === 'zoneAddress' || item.value === 'auditName' || item.value === 'userName' || item.value === 'mangerVOList') {
    return 80;
  } else if (item.value === 'alertDay') {
    return lang.value !== "zh-CN" ? 150 : 80;
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 120 : 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else {
    return "auto"
  }
}
const handleClickSelectMinWidth = (item) => {
  if (item.value === "customerOrigin" || item.value === 'customerIntention') {
    return 140;
  } else if (item.value === 'alertDay') {
    return 180;
  } else {
    return 120;
  }
}


const overflowMap = reactive({})

const setRef = (el, row) => {
  if (!el) {
    delete refMap[row.id]
    delete overflowMap[row.id]
    return
  }
  refMap[row.id] = el

  nextTick(() => {
    overflowMap[row.id] = Math.ceil(el.scrollWidth) >= Math.ceil(el.clientWidth)
  })
}

const handleMouseEnter = (row) => {
  if (overflowMap[row.id]) {
    handleRef(refMap[row.id], row, 5)
  }
}

</script>

<style lang="less" scoped>
@import "../../less/page.less";
@import "./less/follow.less";

#sp_tables {
  :deep(.el-checkbox__input.is-disabled) {
    opacity: 1 !important;
  }

  :deep(.el-checkbox__input.is-disabled .el-checkbox__inner) {
    background-color: #ffffff !important;
    border-color: var(--el-border-color, #dcdfe6) !important;
    cursor: not-allowed !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner),
  :deep(.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner) {
    background-color: var(--el-color-primary, #409eff) !important;
    border-color: var(--el-color-primary, #409eff) !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after) {
    border-color: #ffffff !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner::before) {
    background-color: #ffffff !important;
  }
}

/* 全选所有页时隐藏表头全选框；未全选时正常展示 */
:deep(.disabledCheck .el-checkbox__input) {
  display: none !important;
  padding: 0 !important;
}

:deep(.abledCheck .el-checkbox__input) {
  display: block !important;
  padding: 0 !important;
}

:deep(.disabledCheck) {
  padding: 0 !important;
}

:deep(.abledCheck) {
  padding: 0 !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.tag-popover-trigger {
  margin-left: 4px;
  padding: 0;
  height: auto;
}

.follow-setting-actions {
  display: inline-flex;
  align-items: center;
  column-gap: 5px;
}

.follow-setting-action-btn {
  margin-left: 0 !important;
  padding: 0;
}

.popover-tag-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.popover-tag-item {
  margin-bottom: 8px;
}

.popover-tag-item:last-child {
  margin-bottom: 0;
}
</style>
